import { getCookie, setCookie } from '../../mixins/cookie';

import { messagePopup, displayMessagePopup } from '../../mixins/snackbar';

const { __ } = wp.i18n;
const addCompareTooltipText = WCBT_COMPARE_OBJECT.add_compare_tooltip_text || '';
const removeCompareTooltipText = WCBT_COMPARE_OBJECT.remove_compare_tooltip_text || '';
const userId = WCBT_GLOBAL_OBJECT.user_id || '';

const wcbtToggleCompareProduct = () => {
	document.addEventListener( 'click', function( event ) {
		const compareBtnNodes = document.querySelectorAll( '.wcbt-product-compare' );
		for ( let i = 0; i < compareBtnNodes.length; i++ ) {
			const compareBtnNode = compareBtnNodes[ i ];
			if ( compareBtnNode.contains( event.target ) ) {
				event.preventDefault();

				handleToggleCompareProduct( compareBtnNode );
			}
		}
	} );

	displayActiveCompare();
	displayCompareCount();
};

//Fix for cache page
const displayActiveCompare = () => {
	if ( userId ) {
		return;
	}

	const compare = getCompareCookie();

	if ( ! compare ) {
		return;
	}

	const compareBtnNodes = document.querySelectorAll( '.wcbt-product-compare' );

	[ ...compareBtnNodes ].map( ( compareBtn ) => {
		const productId = parseInt( compareBtn.getAttribute( 'data-product-id' ) );

		if ( compare.includes( productId ) ) {
			compareBtn.classList.add( 'active' );
		} else {
			compareBtn.classList.remove( 'active' );
		}
	} );
};

//Fix for cache page
const displayCompareCount = () => {
	if ( userId ) {
		return;
	}

	const compare = getCompareCookie();
	let count = 0;
	if ( compare ) {
		count = compare.length;
	}

	const countNodes = document.querySelectorAll( '.wcbt-show-compare .count' );

	[ ...countNodes ].map( ( countNode ) => {
		countNode.innerHTML = count;
	} );
};

const handleToggleCompareProduct = ( compareBtnNode = null, productId = null ) => {
	let productIds = getCompareCookie();

	if ( productIds === null || ! productIds ) {
		productIds = [];
	}

	if ( compareBtnNode !== null ) {
		productId = compareBtnNode.getAttribute( 'data-product-id' );
		productId = parseInt( productId );
	}

	let added = true;
	if ( productIds ) {
		//Remove compare product
		if ( productIds.includes( productId ) ) {
			added = false;
			productIds = productIds.filter( ( item ) => item !== productId );
		} else {
			productIds.push( productId );
		}
	} else {
		productIds = [ productId ];
	}

	if ( compareBtnNode !== null ) {
		if ( added === true ) {
			compareBtnNode.classList.add( 'active' );
			messagePopup.innerHTML = __( 'Product Compare added', 'wcbt' );
		} else {
			compareBtnNode.classList.remove( 'active' );
			messagePopup.innerHTML = __( 'Product Compare removed', 'wcbt' );
		}
		compareTooltip( compareBtnNode );
	}

	setCookie( 'wcbt_compare_product', productIds.join( ',' ), 30 );
	displayMessagePopup();
	updateTotal( productIds.length );
};

const getCompareCookie = () => {
	const productIds = getCookie( 'wcbt_compare_product' );
	if ( productIds === null || ! productIds ) {
		return [];
	}

	return productIds.split( ',' ).map( Number );
};

const updateTotal = ( total ) => {
	const compareCountNodes = document.querySelectorAll( '.wcbt-show-compare .count' );

	[ ...compareCountNodes ].map( ( compareCountNode ) => {
		compareCountNode.innerHTML = total;
	} );
};

const compareTooltip = ( productComparetNode ) => {
	const tooltipNode = productComparetNode.querySelector( 'span.tooltip' );

	if ( ! tooltipNode ) {
		return;
	}

	if ( productComparetNode.classList.contains( 'active' ) ) {
		tooltipNode.innerHTML = removeCompareTooltipText;
	} else {
		tooltipNode.innerHTML = addCompareTooltipText;
	}
};

export { getCompareCookie };
export default wcbtToggleCompareProduct;

